(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comf-catalog-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comf-catalog-filters')) {
    customElements.define('comf-catalog-filters', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        this.abort?.abort();
        window.removeEventListener('popstate', this.onPop);
      }
      setup() {
        if (this.ready || !this.isConnected) return;
        this.scope = this.closest('[data-section-type="collection"]');
        this.grid = this.scope?.querySelector('.collection-products');
        if (!this.grid) return;
        this.ready = true;
        this.abort = new AbortController();
        this.original = Array.from(this.grid.children);
        this.size = this.querySelector('[data-comf-size]');
        this.color = this.querySelector('[data-comf-color]');
        this.status = this.querySelector('[role="status"]');
        this.retry = this.querySelector('[data-comf-retry]');
        this.hidden = false;
        this.querySelector('[data-comf-controls]').hidden = false;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-comf-clear]')) { this.size.value = ''; this.color.value = ''; this.change(); }
          if (event.target.closest('[data-comf-retry]')) this.apply();
        }, { signal: this.abort.signal });
        this.addEventListener('change', () => this.change(), { signal: this.abort.signal });
        this.scope.addEventListener('input', event => {
          if (event.target.closest('.sorting-and-filtering')) event.stopImmediatePropagation();
        }, { capture: true, signal: this.abort.signal });
        for (const type of ['change', 'submit']) this.scope.addEventListener(type, event => {
          const form = event.target.closest('form');
          if (!form?.closest('.sorting-and-filtering')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const url = new URL(location.href);
          for (const key of Array.from(url.searchParams.keys())) if (key.startsWith('filter.')) url.searchParams.delete(key);
          for (const [name, value] of new FormData(form)) {
            if (value && (name.startsWith('filter.') || name === 'sort_by')) {
              if (name === 'sort_by') url.searchParams.set(name, value);
              else url.searchParams.append(name, value);
            }
          }
          url.searchParams.delete('page');
          location.assign(url);
        }, { capture: true, signal: this.abort.signal });
        this.scope.addEventListener('click', event => {
          const link = event.target.closest('.sorting-and-filtering a[href]');
          if (!link || link.getAttribute('href').startsWith('#')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const url = new URL(link.href);
          for (const key of ['comf_category', 'comf_size', 'comf_color', 'preview_theme_id']) {
            const value = new URL(location.href).searchParams.get(key);
            if (value) url.searchParams.set(key, value);
          }
          location.assign(url);
        }, { capture: true, signal: this.abort.signal });
        this.onPop = () => { this.readURL(); this.apply(); };
        window.addEventListener('popstate', this.onPop);
        this.readURL();
        this.apply();
      }
      readURL() {
        const params = new URL(location.href).searchParams;
        const category = params.get('comf_category') || 'all';
        this.category = ['all', 'tops', 'bottoms', 'women', 'sets', 'accessories'].includes(category) ? category : 'all';
        this.size.value = params.get('comf_size') || '';
        this.color.value = params.get('comf_color') || '';
      }
      change() {
        const url = new URL(location.href);
        for (const [name, value] of [['comf_category', this.category === 'all' ? '' : this.category], ['comf_size', this.size.value], ['comf_color', this.color.value]]) {
          value ? url.searchParams.set(name, value) : url.searchParams.delete(name);
        }
        history.pushState({}, '', url);
        this.apply();
      }
      normalizeSize(value) {
        return ({ SMALL: 'S', MEDIUM: 'M', LARGE: 'L', '2XL': 'XXL', '3XL': 'XXXL' })[value.toUpperCase()] || value.toUpperCase();
      }
      cardData(card) {
        const data = JSON.parse(card.querySelector('[data-comf-card-data]').textContent);
        const title = data.title.toLowerCase();
        data.category = /set|suit|bundle|pack/.test(title) ? 'sets' : /pant|short|skirt/.test(title) ? 'bottoms' : /tee|shirt|hoodie|jacket|sweater|crew|quarter zip|cut off|tank/.test(title) ? 'tops' : 'accessories';
        data.women = /women|baby tee|tennis skirt|flow pants/.test(title);
        const shade = title.match(/["“']([^"”]+)["”]\s*$/)?.[1] || '';
        data.color = /camo/.test(shade) ? 'camo' : /black/.test(shade) ? 'black' : /white/.test(shade) ? 'white' : /gray|grey/.test(shade) ? 'gray' : /cream/.test(shade) ? 'cream' : /ivory/.test(shade) ? 'ivory' : /navy/.test(shade) ? 'navy' : /blue/.test(shade) ? 'blue' : /green|olive/.test(shade) ? 'green' : /pink/.test(shade) ? 'pink' : /coral/.test(shade) ? 'coral' : /maroon/.test(shade) ? 'maroon' : /mauve/.test(shade) ? 'mauve' : /red/.test(shade) ? 'red' : /lavender|purple/.test(shade) ? 'purple' : /silver/.test(shade) ? 'silver' : '';
        data.sizeIndexes = data.options.map((name, index) => /size/i.test(name) && !/shoe/i.test(name) ? index : -1).filter(index => index >= 0);
        return { card, data, href: card.getAttribute('href') };
      }
      async allCards() {
        if (this.catalog) return this.catalog;
        if (this.pending) return this.pending;
        this.pending = (async () => {
          const pages = Number(this.grid.dataset.comfPages);
          const current = Number(this.grid.dataset.comfPage);
          if (!pages || !current) throw new Error('Missing pagination');
          const results = new Map([[current, this.original.filter(node => node.matches('a.collection-product'))]]);
          const queue = Array.from({ length: pages }, (_, index) => index + 1).filter(page => page !== current);
          const base = new URL(location.href);
          ['comf_category', 'comf_size', 'comf_color', 'sections'].forEach(key => base.searchParams.delete(key));
          base.searchParams.set('section_id', this.dataset.sectionId);
          await Promise.all(Array.from({ length: Math.min(3, queue.length) }, async () => {
            while (queue.length) {
              const page = queue.shift();
              const url = new URL(base);
              url.searchParams.set('page', page);
              const response = await fetch(url, { signal: this.abort.signal, credentials: 'same-origin' });
              if (!response.ok) throw new Error('Collection request failed');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const grid = doc.querySelector('.collection-products[data-comf-pages]');
              if (!grid || Number(grid.dataset.comfPage) !== page) throw new Error('Incomplete collection');
              results.set(page, Array.from(grid.querySelectorAll(':scope > a.collection-product')));
            }
          }));
          this.catalog = Array.from(results).sort((a, b) => a[0] - b[0]).flatMap(([, cards]) => cards.map(card => this.cardData(card)));
          return this.catalog;
        })();
        try { return await this.pending; } finally { this.pending = null; }
      }
      preserveNativeFilters() {
        for (const form of this.scope.querySelectorAll('.sorting-and-filtering form')) {
          for (const [name, value] of [['comf_category', this.category === 'all' ? '' : this.category], ['comf_size', this.size.value], ['comf_color', this.color.value]]) {
            let field = form.querySelector(`input[name="${name}"]`);
            if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.append(field); }
            field.value = value;
          }
        }
      }
      async apply() {
        const revision = this.revision = (this.revision || 0) + 1;
        const active = this.category !== 'all' || this.size.value || this.color.value;
        this.querySelector('[data-comf-clear]').hidden = !(this.size.value || this.color.value);
        this.querySelector('[data-comf-size-note]').hidden = !this.size.value;
        const nativeCount = Array.from(new URL(location.href).searchParams.keys()).filter(name => name.startsWith('filter.')).length;
        const filterCount = Number(Boolean(this.size.value)) + Number(Boolean(this.color.value)) + nativeCount;
        const count = this.querySelector('[data-comf-filter-count]');
        count.textContent = `(${filterCount})`;
        count.hidden = !filterCount;
        document.dispatchEvent(new CustomEvent('comf:filters-change'));
        this.retry.hidden = true;
        this.preserveNativeFilters();
        if (!active) {
          this.original.forEach(node => { node.hidden = false; });
          this.catalog?.forEach(({ card, href }) => { card.setAttribute('href', href); });
          this.grid.replaceChildren(...this.original);
          this.grid.removeAttribute('aria-busy');
          this.status.textContent = '';
          return;
        }
        this.grid.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        try {
          const cards = await this.allCards();
          if (revision !== this.revision || !this.isConnected) return;
          const matches = [];
          for (const { card, data, href } of cards) {
            if (this.category !== 'all' && (this.category === 'women' ? !data.women : data.category !== this.category)) continue;
            if (this.color.value && data.color !== this.color.value) continue;
            const variant = this.size.value ? data.variants.find(variant => variant.available && data.sizeIndexes.length && data.sizeIndexes.every(index => this.normalizeSize(variant.options[index]) === this.size.value)) : null;
            if (this.size.value && !variant) continue;
            const url = new URL(href, location.origin);
            if (variant) url.searchParams.set('variant', variant.id);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) url.searchParams.set('preview_theme_id', preview);
            card.setAttribute('href', url.pathname + url.search);
            card.hidden = false;
            matches.push(card);
          }
          this.grid.replaceChildren(...matches);
          this.status.textContent = matches.length ? this.dataset.count.replace('[count]', matches.length) : this.dataset.empty;
        } catch (error) {
          if (error.name === 'AbortError' || revision !== this.revision) return;
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
        } finally {
          if (revision === this.revision) this.grid.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comf-color-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comf-color-links')) {
    customElements.define('comf-color-links', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link) return;
          const scope = this.closest('.product');
          const values = Array.from(scope?.querySelectorAll('.variant-wrapper input[type="radio"]:checked, .variant-wrapper select') || []).map(input => input.value);
          const variants = JSON.parse(link.querySelector('[data-comf-color-variants]').textContent);
          const match = variants.find(variant => variant.available && values.length === variant.options.length && variant.options.every((option, index) => option === values[index]));
          const url = new URL(link.href);
          url.searchParams.delete('variant');
          if (match) url.searchParams.set('variant', match.id);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          link.href = url.pathname + url.search;
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comf-header-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comf-header-navigation')) {
    customElements.define('comf-header-navigation', class extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('.section-header');
        if (!this.header) return;
        this.sync = () => {
          const current = new URL(location.href);
          const valid = ['tops', 'bottoms', 'women', 'sets', 'accessories'];
          const selected = valid.includes(current.searchParams.get('comf_category')) ? current.searchParams.get('comf_category') : '';
          for (const link of this.header.querySelectorAll('.main-nav > ul.root > li > a[href], .side-nav ul.root > li > a[href]')) {
            const target = new URL(link.href);
            if (!target.pathname.endsWith('/collections/all')) continue;
            const category = target.searchParams.get('comf_category') || '';
            const sort = target.searchParams.get('sort_by');
            const newest = current.searchParams.get('sort_by') === 'created-descending';
            const active = current.pathname === target.pathname && category === selected && (selected ? true : sort ? current.searchParams.get('sort_by') === sort : !newest);
            link.classList.toggle('active', active);
            if (active) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          }
        };
        this.sync();
        window.addEventListener('popstate', this.sync);
        document.addEventListener('comf:filters-change', this.sync);
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.sync);
        document.removeEventListener('comf:filters-change', this.sync);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comf-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comf-mobile-buy-bar')) {
    customElements.define('comf-mobile-buy-bar', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.abort?.abort();
      }
      setup() {
        if (this.ready || !this.isConnected) return;
        const id = this.dataset.sectionId;
        this.original = document.getElementById(`addToCart-${id}`);
        this.form = document.getElementById(`ProductForm-${id}`);
        this.price = document.getElementById(`productPrice-${id}`);
        this.scope = this.original?.closest('.product');
        if (!this.original || !this.form || !this.scope) return;
        this.container = this.closest('.shopify-section') || this.parentElement;
        this.ready = true;
        this.abort = new AbortController();
        this.action = this.querySelector('[data-comf-buy-action]');
        this.action.addEventListener('click', () => {
          this.sync();
          if (!this.original.disabled && !this.action.disabled) this.original.click();
        }, { signal: this.abort.signal });
        this.querySelector('[data-comf-change-size]').addEventListener('click', () => {
          const picker = this.scope.querySelector('.variant-wrapper');
          (picker || this.original).scrollIntoView({ behavior: 'smooth', block: 'center' });
          (picker?.querySelector('input:checked, select') || this.original).focus({ preventScroll: true });
        }, { signal: this.abort.signal });
        this.container.addEventListener('change', () => requestAnimationFrame(() => this.sync()), { signal: this.abort.signal });
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.sync();
        });
        this.observer.observe(this.container, { attributes: true, childList: true, subtree: true, characterData: true });
        this.visibility = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        });
        this.visibility.observe(this.original);
        this.sync();
      }
      sync() {
        const id = this.dataset.sectionId;
        const button = document.getElementById(`addToCart-${id}`);
        this.form = document.getElementById(`ProductForm-${id}`);
        this.price = document.getElementById(`productPrice-${id}`);
        if (!button || !this.form) { this.action.disabled = true; return; }
        if (button !== this.original) {
          this.original = button;
          this.scope = button.closest('.product');
          this.visibility?.disconnect();
          this.visibility?.observe(button);
        }
        const variant = this.form.querySelector('input[name="id"]');
        this.action.disabled = this.original.disabled || this.original.classList.contains('loading') || !variant?.value || variant.disabled;
        this.action.textContent = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
        this.querySelector('[data-comf-buy-price]').textContent = this.price?.textContent.trim() || '';
        const values = Array.from(this.scope.querySelectorAll('.variant-wrapper input[type="radio"]:checked, .variant-wrapper select')).map(input => input.value);
        this.querySelector('[data-comf-buy-options]').textContent = values.join(' / ');
        this.querySelector('[data-comf-change-size]').hidden = !values.length;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comf-ombre-set-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comf-set-picker')) {
    customElements.define('comf-set-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const choices = Array.from(this.querySelectorAll('[data-set-choice]'));
        const button = this.querySelector('[data-set-add]');
        const status = this.querySelector('[data-set-status]');
        const label = button.textContent;
        let busy = false;
        const update = () => {
          button.disabled = busy || choices.some(select => !select.value || select.selectedOptions[0].disabled);
          if (!busy) status.textContent = '';
        };
        choices.forEach(select => select.addEventListener('change', update));
        button.addEventListener('click', async () => {
          if (busy || choices.some(select => !select.value || select.selectedOptions[0].disabled)) return;
          busy = true;
          button.disabled = true;
          button.textContent = this.dataset.loading;
          status.textContent = '';
          try {
            const response = await fetch(this.dataset.cartAdd, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: choices.map(select => ({ id: Number(select.value), quantity: 1 })) })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
            busy = false;
            button.textContent = label;
            button.disabled = choices.some(select => !select.value || select.selectedOptions[0].disabled);
          }
        });
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
